import { toast } from "react-hot-toast";
import { publicRequest } from "../requestMethod"
import { loginFailure, loginStart, loginSuccess } from "./userRedux"

export const login = async(dispatch,user)=>{
    // console.log(user);
    const toastId=toast.loading("loging...")
    dispatch(loginStart())
    try {
        const res= await publicRequest.post('/auth/login',user)
        // console.log({res});
        
        dispatch(loginSuccess(res.data))
        
        toast.success("welcome "+res.data.toBeSent.username)
        toast.remove(toastId)
    } catch (error) {
        toast.remove(toastId)
        console.log(error);
        toast.error(error?.response.data.message)
        dispatch(loginFailure())
        toast.error("error");
    }
}